import React from "react";
import useStyles from "../styles";
import { TextField } from "@material-ui/core";

const InputDisableSimpleText = ({ value, type, label, name, placeholder, isPrice }) => {
    const classes = useStyles();

    return (
        <div>
            <label className={classes.label} >{label}</label>
            <div style={{ display: "flex", justify: "center", alignItems: "center" }}>
                {isPrice ? (
                    <p style={{ fontSize: "18px" }}>$</p>
                ) : (
                    <></>
                )}
                <TextField
                    disabled="true"
                    InputProps={{
                        classes: {
                            focused: classes.textBorder,
                            input: classes.inputForm,
                        },
                    }}
                    value={value}
                    placeholder={placeholder}
                    type={type}
                    name={name}
                    style={{ width: '85%' }}
                    inputStyle={{ width: '85%' }}
                />
            </div>
        </div >
    );
}

export default InputDisableSimpleText;